import AuthLayout from '@/views/Pages/AuthLayout.vue';
import NotFound from '@/views/Theme/GeneralViews/NotFoundPage.vue';

// Pages
const Login = () => import(/* webpackChunkName: "auth-pages" */ '@/views/Pages/Login.vue');
const Register = () => import(/* webpackChunkName: "auth-pages" */ '@/views/Pages/Register.vue');

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/login',
      name: 'Login',
      meta: { auth: false },
      component: Login,
    },
    {
      path: '/register',
      name: 'Register',
      meta: { auth: false },
      component: Register,
    },
    { path: '*', component: NotFound },
  ],
};

export default authPages;
